<template>
	<view id="root"></view>
</template>

<script>
import qs from 'qs';
import service from '../utils/request';
import QRCode from 'qrcodejs2';

export default {
	data() {
		return {
			param: {
				username: '',
				password: ''
			},
			rules: {
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
			},
			isActive: true,
			timer_interval: '',
			isActiveIndex: 0,
			isCode: true,
			headPortrait: '',
			account: '',
			logoimg2: false,
			difgAl: ['difgAl0', 'difgAl1', 'difgAl2', 'difgAl3'],
			carouselList: [
				{
					carouselURL: 'https://images.10000.work/swipe1.jpg'
				},
				{
					carouselURL: 'https://images.10000.work/swipe2.jpg'
				},
				{
					carouselURL: 'https://images.10000.work/swipe3.jpg'
				},
				{
					carouselURL: 'https://images.10000.work/swipe4.jpg'
				}
			],
			carouselHeight: document.documentElement.clientHeight + 'px',
			qrcodeshow: true,
			qrcodeerweimashow: false,
			mypagestyle: { transform: 'translateX(0px)' }
		};
	},
	created() {
		this.$store.commit('clearTags');
		this.carouselHeight = document.documentElement.clientHeight + 'px';
	},
	methods: {
		getqrcodeshow() {
			this.qrcodeshow = true;
		},
		outqrcodeshow() {
			this.qrcodeshow = false;
		},
		submitForm() {
			this.$refs.login.validate(valid => {
				if (valid) {
					this.getlogin();
				} else {
					this.$message.error('请输入账号和密码');
					return false;
				}
			});
		},
		getlogin() {
			const value = {
				account: this.param.username,
				password: this.param.password
			};
			service
				.post('/api/login/auth', qs.stringify(value))
				.then(res => {
					if (res.code == 200) {
						localStorage.setItem('ms_username', res.data.account);
						localStorage.setItem('ms_role', res.data.role);
						localStorage.setItem('token', 'Bearer ' + res.data.token);
						localStorage.setItem('lastLoginIp', res.data.lastLoginIp);
						localStorage.setItem('lastLoginAt', res.data.lastLoginAt);
						localStorage.setItem('user', res.data.user);
						localStorage.setItem('setSeconds', res.data.intervals);
						localStorage.setItem('company', res.data.company);
						localStorage.setItem('userId', JSON.stringify(res.data.userId));
						localStorage.setItem('companyId', JSON.stringify(res.data.companyId));
						localStorage.setItem('protectionLevel', JSON.stringify(res.data.protectionLevel));
						this.$message.success('登录成功');

						if (res.data.role == 'gm') {
							this.$router.push('/GM');
						} else {
							this.$router.push('/');
						}
					} else {
						this.$message.error(res.message);
					}
				})
				.catch(error => {
					console.log(error);
					this.errored = true;
				});
		},

		accountLogin() {
			// 账号登录
			this.isActive = true;
			this.isActiveIndex = 0;
			clearInterval(this.timer_interval);
			this.logoimg2 = false;
			this.qrcodeshow = true;
			this.qrcodeerweimashow = false;
		},
		smsLogin() {
			// 二维码
			this.isActive = false;
			this.isActiveIndex = 1;
			this.isCode = true;
			setTimeout(() => {
				this.qrcodeshow = false;
			}, 5000);
			if (this.logoimg2 == false) {
				this.getQrLogin();
			}
		},
		getQrLogin() {
			service
				.get('/api/login/QrLogin')
				.then(res => {
					if (res.code === 200) {
						this.qrcodeHtml = res.data;
						this.timer_interval = setInterval(() => {
							this.queryStatus();
						}, 1000);
						this.GenerateQRCode();
					} else {
						this.$message.error(res.message);
					}
				})
				.catch(error => {
					this.errored = true;
				});
		},
		// 生成二维码
		GenerateQRCode() {
			const qrcode = new QRCode('qrcode', {
				width: 200, // 二维码宽度，单位像素
				height: 200, // 二维码高度，单位像素
				colorDark: '#000000',
				colorLight: '#ffffff',
				text: this.qrcodeHtml // 生成二维码的链接
			});
			this.qrcodeerweimashow = true;
			this.logoimg2 = true;
		},
		//查询扫码登录状态   invalid (二维码是否过期false==未过期) ScanCode(false==未扫码)
		queryStatus() {
			let data = {
				l: this.qrcodeHtml
			};
			service
				.get('/api/login/queryStatus?l=' + this.qrcodeHtml)
				.then(res => {
					if (res.code === 200) {
						console.log(res, 'headPortrait');
						if (res.data.invalid == false) {
							//是否过期
							if (res.data.ScanCode == true) {
								if (res.data.login == false) {
									this.isCode = false;
									this.account = res.data.account;
									this.headPortrait = res.data.headPortrait;
								} else {
									this.param.username = res.data.account;
									this.param.password = res.data.password;
									clearInterval(this.timer_interval);
									this.getlogin();
								}
							}
						} else {
							this.$message.error('二维码超时');
							clearInterval(this.timer_interval);
							this.accountLogin();
						}
					} else {
						this.$message.error(res.message);
					}
				})
				.catch(error => {
					this.errored = true;
				});
		}
	}
};
</script>

<style scoped>
#root {
	position: fixed;
	top: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	overflow-y: auto;
}
.login-box {
	background: #fff;
	height: 100%;

	overflow: hidden;
	min-height: 670px;
	display: flex;
	flex-direction: row;
	position: relative;
}
.login-left {
	position: relative;

	width: 100%;
	height: 100%;
}

/deep/ .el-carousel {
	height: 100% !important;
}
/deep/ .el-carousel img {
	width: 100%;
	height: 100%;
}
.login-right {
	position: fixed;
	width: 550px;
	height: 670px;
	padding-bottom: 52px;
	box-sizing: border-box;
	right: 10%;
	top: 50%;
	transform: translateY(-50%);
	background: #fff;
	box-shadow: 0 4px 20px 0 rgb(0 54 128 / 8%);
	z-index: 99;
}
.hnezGK {
	height: 100%;
	min-height: 598px;
}
.kjkerh {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	width: 70%;
	height: 100%;
	max-width: 450px;
	min-width: 288px;
	min-height: 575px;
	margin: 0px auto;
	padding: 0px;
}
.bBMinK {
	width: 100%;
	height: auto;
	margin-bottom: 0px;
}

.eoLAua {
	position: relative;
	display: flex;
	justify-content: space-between;
}
.eoLAua div {
	display: flex;
	font-size: 12px;
	line-height: 22px;
	color: rgb(157, 165, 179);
}
.eoLAua div a {
	color: rgb(95, 122, 184);
	text-decoration: none;
	font-size: 12px;
	cursor: pointer;
}
/deep/.login-left .el-carousel .el-carousel__container {
	height: 100% !important;
}

.ms-content {
	margin-top: 60px;
	width: 100%;
	height: 400px;
}
/deep/.ms-content .el-form-item {
	margin-bottom: 36px;
}
.bBMinK .login_title {
	text-align: center;
	margin: 0px 20px 25px 20px;
	color: rgba(17, 31, 44, 0.6);
	letter-spacing: 0;
	cursor: pointer;
}
.login_title span {
	margin: 20px;
	font-size: 24px;

	cursor: pointer;
}
.login_title span:hover {
	color: #333;
	font-weight: bolder;
	font-weight: 600;
}
.isActiveTitle {
	color: #333;
	font-weight: 600;
	padding-bottom: 10px;
	border-bottom: 2px solid #5d84fd;
}
.login-btn {
	text-align: center;
	margin-top: 36px;
}
.login-btn button {
	width: 100%;
	height: 45px;
	margin-bottom: 10px;
	font-size: 20px;
	border-radius: 0;
}
.login-tips {
	font-size: 12px;
	line-height: 30px;
	color: #fff;
}
/deep/.el-input__inner {
	height: 50px;
	line-break: 50px;
	border-radius: 0;
}
/deep/.el-input-group__prepend {
	border-radius: 0;
}
.ms-right {
	float: left;
	width: 450px;
	box-sizing: border-box;
}

.kbTWYa {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	max-width: 450px;
	position: absolute;
	bottom: 40px;
}
.jGryIZ {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 100%;
}
.hYCxqF {
	display: block;
	margin-top: 9px;
	padding-left: 25px;
	font-size: 12px;
	color: rgb(157, 165, 179);
	position: relative;
	right: -40px;
}
.hYCxqF::before {
	content: url(//aucrs.ingageapp.com/login/static/media/filing.d0289dc0.png);
	position: absolute;
	left: 0px;
	top: -1px;
}
.bhXrfM {
	width: 176px;
	padding: 10px 0px;
	background: rgb(255, 255, 255);
	display: none;
	z-index: 999;
}

.ghrOLy {
	height: 152px;
	width: 152px;
	margin: 0px auto;
	display: block;
}
.dZwbCj {
	font-size: 12px;
	color: rgba(25, 31, 37, 0.72);
	text-align: center;
}
.gXoFpm:hover .bhXrfM {
	display: block;
	position: absolute;
	top: -205px;
	left: -45px;
	border: 1px solid #ccc;
	animation-name: xianshi;
	animation-duration: 1s;
}
@keyframes xianshi {
	0% {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}
.gXoFpm {
	display: block;
	width: 78px;
	height: 32px;
	margin-right: 12px;
	padding-left: 29px;
	border: none;
	border-radius: 16px;
	font-size: 12px;
	color: rgb(157, 165, 179);
	line-height: 16px;
	background-color: rgb(248, 249, 252);
	position: relative;
	cursor: pointer;
}
.gXoFpm::before {
	content: url(//aucrs.ingageapp.com/login/static/media/IOS.8a7ae521.svg);
	position: absolute;
	top: 6px;
	left: 8px;
}
.kpYSMU {
	display: block;
	width: 78px;
	height: 32px;
	margin-right: 12px;
	padding-left: 29px;
	border: none;
	border-radius: 16px;
	font-size: 12px;
	color: rgb(157, 165, 179);
	line-height: 16px;
	background-color: rgb(248, 249, 252);
	position: relative;
	cursor: pointer;
}
.kpYSMU::before {
	content: url(//aucrs.ingageapp.com/login/static/media/Android.039cc413.svg);
	position: absolute;
	top: 6px;
	left: 8px;
}
.kpYSMU:hover .bhXrfM {
	display: block;
	position: absolute;
	top: -205px;
	left: -45px;
	border: 1px solid #ccc;
	animation-name: xianshi;
	animation-duration: 1s;
}
.iRDvLn {
	display: flex;
}

.v-0d8 {
	text-align: center;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	flex-direction: column;
	user-select: none;
	padding-top: 20px;
}
.ant-spin-nested-loading {
	position: relative;
}
.ant-spin-container {
	position: relative;
	transition: opacity 0.3s;
}
.v-0d8 ._1UQFT {
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	height: 300px;
}
.v-0d8 ._2cVmK {
	margin-top: 12px;
	width: 32px;
	cursor: pointer;
}

.v-0d8 ._1jQx1 {
	font-size: 14px;
	color: rgba(17, 31, 44, 0.6);
	letter-spacing: 0;
	text-align: center;
	line-height: 20px;
	margin-top: 24px;
	cursor: pointer;
}
.ant-spin-container:after {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 10;
	display: none\9;
	width: 100%;
	height: 100%;
	background: #fff;
	opacity: 0;
	transition: all 0.3s;
	content: '';
	pointer-events: none;
}
.v-0d8 ._3grbl {
	position: relative;
	height: 200px;
	width: 200px;
	z-index: 9;
	transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.v-0d8 ._1UQFT ._1LuAn {
	width: 220px;
	z-index: 1;
	margin-right: -30px;
}
.v-0d8 ._1UQFT ._1LuAn._2Akme {
	animation: IJw-y 3s 1 forwards;
}
.v-0d8 ._3grbl .WLAvM {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
}
.v-0d8 ._3grbl ._3Z7di {
	position: absolute;
	width: 52px;
	height: 52px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}
.v-0d8 ._3grbl .xWnCM {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: hsla(0, 0%, 100%, 0.9);
	cursor: pointer;
}
.v-0d8 ._3grbl .xWnCM ._3eFxE {
	margin-top: 76px;
	width: 48px;
	height: 48px;
	transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.v-0d8 ._3grbl .xWnCM .lAlbv {
	margin-top: 12px;
	font-size: 14px;
	color: #08f;
	letter-spacing: 0;
	text-align: center;
}
.v-0d8 ._2cVmK {
	margin-top: 12px;
	width: 32px;
	cursor: pointer;
}
.v-0d8 ._1jQx1 {
	font-size: 14px;
	color: rgba(17, 31, 44, 0.6);
	letter-spacing: 0;
	text-align: center;
	line-height: 20px;
	margin-top: 24px;
	cursor: pointer;
}
</style>
